import { useState } from "react";
import { Navigate, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "./AuthContext";
import { errorText } from "../lib/api";
import { Logo } from "../components/Brand";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
    } catch (err) {
      setError(errorText(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative grid min-h-screen place-items-center bg-navy px-5 grain">
      <div className="absolute inset-0 grid-lines" />
      <form onSubmit={submit} data-testid="admin-login-form" className="relative w-full max-w-md rounded-[26px] border border-white/10 bg-navy-deep/80 p-8 backdrop-blur-xl sm:p-10">
        <Link to="/"><Logo /></Link>
        <h1 className="mt-8 font-display text-4xl font-extrabold uppercase text-white">Admin login</h1>
        <p className="mt-1 text-sm text-slate-400">Manage enquiries, products and settings.</p>
        <label className="mt-8 block">
          <span className="mb-2 block text-sm font-semibold text-slate-200">Email</span>
          <input data-testid="admin-login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="field" />
        </label>
        <label className="mt-5 block">
          <span className="mb-2 block text-sm font-semibold text-slate-200">Password</span>
          <input data-testid="admin-login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="field" />
        </label>
        {error && <p data-testid="admin-login-error" className="mt-4 text-sm text-red-400">{error}</p>}
        <button data-testid="admin-login-submit-button" disabled={loading} className="mt-8 flex w-full items-center justify-center gap-2 rounded-full bg-brand py-4 font-semibold text-white transition-colors hover:bg-brand-dark disabled:opacity-60">
          {loading && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
        </button>
      </form>
    </div>
  );
}
